<template>
  <div>
    <AppDownloadBanner mode="company" action-link="/company/job/create" @action-click="handleDetailClick" />
    <div class="footer-wrapper">
      <footer class="main-footer applicant-footer">
        <div class="sec-wrap footer-container">
          <!-- Left Logo/Brand Column -->
          <div class="footer-brand-section">
            <router-link :to="{ name: 'companyIndex' }" class="footer-logo-link">
              <img src="@/assets/images/common/logo_footer.svg" width="60" height="91" alt="BIB Job" />
            </router-link>
            <p class="footer-brand-desc">
              <span class="en bold">BIB JOB</span> သည် မြန်မာနိုင်ငံရှိ နောက်ဆုံးရ အလုပ်အကိုင်များကို တစ်နေရာတည်းတွင်
              အလွယ်တကူရှာဖွေနိုင်ပြီး စိတ်ချရသော အလုပ်ရှင်များနှင့်ချိတ်ဆက်ပေးရန် ရည်ရွယ်ပါသည်။
            </p>
          </div>

          <!-- Right Main Navigation & Contacts Section -->
          <div class="footer-links-contacts-section">
            <!-- Top Nav Links -->
            <nav class="footer-nav-row">
              <router-link :to="{ name: 'companyIndex' }">ပင်မစာမျက်နှာ</router-link>
              <router-link :to="{ name: 'jobPostCategory' }">အလုပ်အမျိုးအစားများ</router-link>
              <router-link :to="{ name: 'companyJobRequest' }">အလုပ်ရှာပိုစ့်များ</router-link>
              <router-link
                :to="{ name: 'jobPostCreate'}">အလုပ်အကိုင်ပိုစ့်တင်ရန်</router-link>
            </nav>

            <!-- Divider Line -->
            <div class="footer-divider"></div>

            <!-- Middle Contact Row -->
            <div class="footer-contact-row">
              <div class="footer-contact-col en">
                <app-icon name="phone" size="20" class="contact-icon-svg" />
                <a href="tel:+959797420117" class="contact-link">09 797 420 117</a>
              </div>
              <div class="footer-contact-col en">
                <app-icon name="mail" size="20" class="contact-icon-svg" />
                <a href="mailto:bib.job.mm@gmail.com" class="contact-link">bib.job.mm@gmail.com</a>
              </div>
              <div class="footer-contact-col address-col">
                <app-icon name="location" size="20" class="contact-icon-svg" />
                <a href="https://maps.app.goo.gl/XxEfMJdLLExhXoXEA" target="_blank" rel="noopener noreferrer"
                  class="contact-link">
                  အမှတ်(၈၈/၉၀)၊ ၄လွှာ၊ ၅၁လမ်း၊ အလယ်ဘလောက်၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။
                </a>
              </div>
            </div>

            <!-- Bottom Social Row -->
            <div class="footer-social-row">
              <a href="https://www.facebook.com/BIBMyanmarJobs" class="social-link" target="_blank" rel="noopener">
                <img src="@/assets/images/common/ico_fb.svg" alt="Facebook" />
              </a>
              <a href="https://www.tiktok.com/@bibjobcompany" class="social-link" target="_blank" rel="noopener">
                <img src="@/assets/images/common/ico_tiktok.svg" alt="TikTok" />
              </a>
              <a href="https://t.me/bibmyanmarjobsagency" class="social-link" target="_blank" rel="noopener">
                <img src="@/assets/images/common/ico_telegram.svg" alt="Telegram" />
              </a>
            </div>
          </div>
        </div>

        <!-- Bottom White Bar for Privacy Policy & Copyright -->
        <div class="footer-bottom-bar">
          <div class="sec-wrap bottom-bar-container">
            <router-link :to="{ name: 'policy' }" class="privacy-link">Privacy Policy</router-link>
            <span class="copyright-text">
              Copyright © BIB Co., Ltd. All rights reserved.
            </span>
          </div>
        </div>

        <!-- Page Top Button -->
        <div class="page-top">
          <a href="#top" id="toTop" class="top-lnk" aria-label="Back to top">
            <img src="@/assets/images/common/img_pagetop01.png" alt="" width="54" height="54" aria-hidden="true"
              loading="lazy" />
          </a>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { mapGetters } from 'vuex';

export default {
  name: "Footer",
  computed: {
    ...mapGetters({
      isCompanyLoggedIn: 'isCompanyLoggedIn',
      companyToken: 'companyToken',
    }),
  },
  methods: {
    handleDetailClick() {
      if (this.isCompanyLoggedIn || this.companyToken) {
        this.$router.push('/company/job/create', () => {});
      } else {
        this.$router.push('/company/login', () => {});
      }
    },
  },
  mounted() {
    const topBtn = $('.page-top');
    topBtn.hide();

    const handleScroll = () => {
      if ($(window).scrollTop() > 100) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    };

    $(window).on('scroll', handleScroll);
    handleScroll();

    $("#toTop").on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
    });

    this._handleScroll = handleScroll;
  },
  beforeDestroy() {
    if (this._handleScroll) {
      $(window).off('scroll', this._handleScroll);
    }
    $("#toTop").off('click');
  }
};
</script>
